export { Splash } from './Splash'
